import React, { createContext, useContext } from "react";
import "react-toastify/ReactToastify.css";
import { toast } from "react-toastify";

export interface NotificationProps {
  type: "default" | "info" | "success" | "warning" | "error";
  content: string;
}

interface NotificationProviderProps {
  addNotification: (props: NotificationProps) => void;
}

const NotificationContext = createContext<NotificationProviderProps>({
  addNotification: () => null,
});

export const useNotification = () => {
  return useContext(NotificationContext);
};

const NotificationProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  function addNotification(props: NotificationProps) {
    switch (props.type) {
      case "info":
        toast.info(props.content);
        break;
      case "success":
        toast.success(props.content);
        break;
      case "warning":
        toast.warning(props.content);
        break;
      case "error":
        toast.error(props.content);
        break;
      default:
        toast(props?.content);
    }
  }

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
